import { z } from '@/libs/zod';

export const exatoHashRequestSchema = z.object({
  customerId: z.string(),
});

export const exatoHashResponseSchema = z.object({
  hash: z.string(),
  cpf: z.string(),
});

export type ExatoHashRequest = z.infer<typeof exatoHashRequestSchema>;
export type ExatoHashResponse = z.infer<typeof exatoHashResponseSchema>;
